import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useState } from 'react';
import create from 'zustand';
import {Grid, TextField} from '@mui/material';
import EmployeeField from '../Relations/EmployeeField';
import useAlert from '../../hooks/useAlert';

const useCommentDialogStore = create((set) => ({
    message: '',
    title: '',
    onSubmit: undefined,
    close: () => set({onSubmit: undefined}),
}));


export const commentWithSupervisorDialog = (title, message, onSubmit) => {
    useCommentDialogStore.setState({
        title,
        message,
        onSubmit,
    });
};

const CommentWithSupervisorDialog = () => {
    const {title, message, onSubmit, close} = useCommentDialogStore();
    const [comment, setComment] = useState(null);
    const [director, setDirector] = useState(null);
    const [directorId, setDirectorId] = useState(null);

    const alert = useAlert(false, 1);

    return (
            <Dialog
                open={Boolean(onSubmit)}
                onClose={close}
            >
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        {message}
                    </DialogContentText>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <TextField
                                required
                                margin="normal"
                                value={comment}
                                onChange={(e) =>
                                    setComment(e.target.value)
                                }
                                fullWidth
                                id="comment"
                                name="comment"
                                label="Комментарий"
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <EmployeeField
                    label={"Заведующий лаборатории/Начальник отдела"}
                    fullWidth
                    extraFilter={{
                        advancedFilter: {
                            roleIds: [5, 19]
                        }
                    }}
                    object={director}
                    value={directorId}
                    onChange={(director) => {
                        setDirector(director);
                        setDirectorId(director?.id ?? null);
                    }}
                />
                <DialogActions>
                    <Button onClick={() => close()} color="error" variant="contained">
                        Отменить
                    </Button>
                    <Button onClick={() => {
                        if (!comment) {
                            alert.show(0, 'Комментарий обязателен для заполнения');
                            return;
                        }
                        if (!directorId) {
                            alert.show(0, 'Необходимо указать директора');
                            return;
                        }
                        if (onSubmit) {
                            onSubmit({ comment, directorId });
                        }
                        close();
                    }} color="primary" variant="contained">
                        Подтвердить
                    </Button>
                </DialogActions>
            </Dialog>
    );
}

export default CommentWithSupervisorDialog;
